"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function useCountdown(options) {
  var start = options.start,
    end = options.end,
    interval = options.interval,
    isIncrement = options.isIncrement,
    onEnd = options.onEnd,
    step = options.step,
    _options$initOnStart = options.initOnStart,
    initOnStart = _options$initOnStart === void 0 ? false : _options$initOnStart;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    countdownEndDate = _useState2[0],
    setCountdownEndDate = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    countdownDate = _useState4[0],
    setCountdownDate = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRunning = _useState6[0],
    setIsRunning = _useState6[1];
  var initCountdown = (0, _react.useCallback)(function () {
    var _start$hours, _start$minutes, _start$seconds;
    setCountdownDate(new Date(0, 0, 0, (_start$hours = start.hours) !== null && _start$hours !== void 0 ? _start$hours : 0, (_start$minutes = start.minutes) !== null && _start$minutes !== void 0 ? _start$minutes : 0, (_start$seconds = start.seconds) !== null && _start$seconds !== void 0 ? _start$seconds : 0).getTime());
    if (end) {
      var _end$hours, _end$minutes, _end$seconds;
      setCountdownEndDate(new Date(0, 0, 0, (_end$hours = end.hours) !== null && _end$hours !== void 0 ? _end$hours : 0, (_end$minutes = end.minutes) !== null && _end$minutes !== void 0 ? _end$minutes : 0, (_end$seconds = end.seconds) !== null && _end$seconds !== void 0 ? _end$seconds : 0).getTime());
    }
  }, [start, end]);
  (0, _react.useEffect)(function () {
    initCountdown();
  }, []);
  var handleCountChange = function handleCountChange() {
    handleDateCountdown();
  };
  var handleDateCountdown = function handleDateCountdown() {
    if (!countdownDate) return;
    var _ = new Date(countdownDate);
    if (isIncrement) {
      _.setSeconds(_.getSeconds() + (step !== null && step !== void 0 ? step : 1));
    } else {
      _.setSeconds(_.getSeconds() - (step !== null && step !== void 0 ? step : 1));
    }
    setCountdownDate(_.getTime());
  };
  (0, _react.useEffect)(function () {
    var _interval;
    if (isRunning) {
      _interval = setInterval(function () {
        handleCountChange();
      }, interval !== null && interval !== void 0 ? interval : 1000);
    }
    return function () {
      clearInterval(_interval);
    };
  }, [isRunning, countdownDate]);
  (0, _react.useEffect)(function () {
    if (end && countdownEndDate && countdownDate && countdownDate <= countdownEndDate) {
      setIsRunning(false);
      onEnd === null || onEnd === void 0 ? void 0 : onEnd();
    }
  }, [end, countdownDate]);
  var startCountdown = function startCountdown() {
    if (initOnStart) {
      initCountdown();
    }
    setIsRunning(true);
  };
  var stopCountdown = function stopCountdown() {
    setIsRunning(false);
  };
  var resetCountdown = function resetCountdown() {
    initCountdown();
  };
  var getReturnValues = function getReturnValues(countDown) {
    if (!countdownDate) return;
    var date = new Date(countDown).toLocaleTimeString([], {
      hour12: false
    });
    var splits = date.split(':');
    return {
      hours: start.hours && splits[0],
      minutes: splits[1],
      seconds: splits[2]
    };
  };
  return {
    countdown: getReturnValues(countdownDate !== null && countdownDate !== void 0 ? countdownDate : 0),
    startCountdown: startCountdown,
    resetCountdown: resetCountdown,
    stopCountdown: stopCountdown
  };
}
var _default = useCountdown;
exports["default"] = _default;